/* モフトレチェック */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as HeaderActions from '../actions/Header';
import UserSelectMoffCheck from '../components/UserSelectMoffCheck';
import * as MoffCheckActions from '../actions/MoffCheck';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
    moffCheckCount: state.moffCheckCount,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
    moffCheckActions : bindActionCreators(MoffCheckActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSelectMoffCheck as any);



// WEBPACK FOOTER //
// ./src/containers/UserSelectMoffCheck.tsx